<template>
  <v-card>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          {{ getProductName(product) }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ product.quantidade_produto }}x
          {{ formatMoney(product[getUnitPrice()]) }}
        </v-list-item-subtitle>
        <v-list-item-subtitle>
          Total {{ formatMoney(calcTotalProduct(product)) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions v-if="readonly === false">
      <v-btn @click="editProduct()" color="primary" small>
        Editar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="removeProduct()" color="red" small dark>
        Remover
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MoneyMixin from "@/mixins/MoneyMixin";

export default {
  mixins: [MoneyMixin],

  props: {
    product: Object,
    index: Number,
    readonly: {
      type: Boolean,
      default: false
    },
    isReturn: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getUnitPrice() {
      return this.isReturn ? "preco_devolucao" : "preco_venda";
    },
    calcTotalProduct(sale_product) {
      return (
        sale_product.quantidade_produto * sale_product[this.getUnitPrice()]
      );
    },
    getProductName(product) {
      return `${product.nome} ${product.marca} (${product.unidade_medida})`;
    },
    editProduct() {
      this.$emit("edit", this.product, this.index);
    },
    removeProduct() {
      this.$emit("remove", this.index);
    }
  }
};
</script>
